import { useNavigate } from 'react-router-dom';
import { Star, Wine } from '@phosphor-icons/react';
import { useStore } from '../../context/StoreContext';
import { getCategoryIcon } from '../../utils/categoryIcons';
import { insights } from '../../services/algoliaInsights';
import { recordEvent } from '../../utils/userProfile';

// Carousel Hit Component for homepage
export const CarouselProductHit = ({ hit }) => {
  const { selectedStore, stores } = useStore();
  const navigate = useNavigate();
  const IconComponent = getCategoryIcon(hit.categorias_flat);
  
  const storeData = hit.store_data?.[`store_${selectedStore.padStart(3, '0')}`];
  const price = storeData?.price || hit.price;
  const available = storeData?.available || hit.stock;
  
  // Check if product is available at selected store for badge
  const availableAtSelectedStore = hit.store_availability?.includes(parseInt(selectedStore));

  const handleClick = () => {
    // Track click event - homepage products are not from search, so always use direct click
    insights.clickedObjectIDs(
      'Homepage Product Click',
      'saq_products',
      [hit.objectID]
    );

    recordEvent({
      type: 'click',
      product: { ...hit, selectedStore: String(selectedStore || '1') },
    });

    navigate(`/produit/${hit.objectID}`);
  };

  return (
    <div className="carousel-card" onClick={handleClick} style={{ borderColor: '#4B164C' }}>
      <div className="card-image-container">
        <div className="card-image-placeholder" style={{ background: '#f8f6fa', borderRadius: 8 }}>
          {hit.image ? (
            <img src={hit.image.startsWith('http') ? hit.image : `https:${hit.image}`} alt={hit.name} style={{ height: 200, borderRadius: 8, width: '100%', objectFit: 'cover' }} />
          ) : (
            <Wine size={48} color="#4B164C" />
          )}
        </div>
      </div>
      <div className="card-content">
        <h3 className="card-title" style={{ color: '#4B164C' }}>{hit.name}</h3>
        <div className="card-category">{hit.attributes?.appellation} {hit.attributes?.millesime_produit} {hit.attributes?.pays_origine}</div>
        <div className="card-price-section">
          <div className="card-price" style={{ color: '#4B164C' }}>Prix: ${hit.price?.toLocaleString('fr-CA', { minimumFractionDigits: 2 })} CAD</div>
          <div className="card-color">{hit.color}</div>
        </div>
        <div className="card-badges">
          {hit.customer_rating && (
            <span className="badge rating" style={{ background: '#fff', color: '#4B164C', border: '1px solid #4B164C' }}>
              <Star size={12} weight="fill" color="#4B164C" />
              {hit.customer_rating}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}; 